<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">

      <!--Breadcrumbs and title embedded within below data page-->
      <div class="container">
        <!-- <component src="https://c2hbe361.caspio.com/dp/76bfd00014f8b8eb37eb4a46870e/emb" :is="'script'">
        </component> -->
      </div>

      <div class="tabs">
        <div class="tab-header">

          <button v-if="showConvHistoryTab" class="tab-button"
            @click="this.$router.push('/partner/conversation-history/voice')"
            :class="{ active: activeTab === 'conv-history' }">Conversation History</button>
          <!-- <button class="tab-button" @click="this.$router.push('/partner/view-bot')"
            :class="{ active: activeTab === 'bot-config' }">Bot Configuration</button> -->
          <button class="tab-button" @click="this.$router.push('/partner/analytics')"
            :class="{ active: activeTab === 'bot-analytics' }">Analytics</button>
        </div>
        <div class="tab-content">
          <div v-if="activeTab === 'conv-history'">
            <!-- Redirect to correct conv history page based on bot type-->
            <div class="container">
              <!-- <component src="https://c2hbe361.caspio.com/dp/76bfd000031af0016e11489788bb/emb" :is="'script'">
              </component> -->
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'
import { medicalBotIds } from "@/config/medicalBots.js"

export default {
  name: 'ViewConversationHistory',
  components: {
    SideBar
  },
  data() {
    return {
      activeTab: 'conv-history', // Default active tab
      showConvHistoryTab: true
    }
  },
  mounted() {
    
    const botId = localStorage.getItem("botID") || '';
    if (medicalBotIds.includes(botId)) {
      this.showConvHistoryTab = false;
    }
    this.$router.push('/partner/conversation-history/voice');
  }
}
</script>
